import React from 'react';
import { Field } from 'react-final-form';

import { fastDepositField } from '../../SavePaymentInfo';

const ForceMakeFastDepositCheckbox: React.FC = () => (
  <Field name={fastDepositField} type="checkbox" initialValue>
    {() => (
      <input
        hidden
        name={fastDepositField}
        type="checkbox"
        data-testid="force-make-fast-deposit-checkbox"
      />
    )}
  </Field>
);

export default ForceMakeFastDepositCheckbox;
